module.exports = __webpack_public_path__ + "static/media/logo.dbcf5ada.png";